<template>
    <div class="v-upload-select" :class="{'v-upload-dragger': type === 'drag', 'is-dragOver': dragover && !disabled, 'v-upload-image-list': type === 'imageList' }" @drop.prevent="fileChange" @dragover.prevent="dragover = true" @dragleave.prevent="dragover = false">
        <div v-if="type === 'fileList'">
            <button type="button" class="btn btn-sm btn-primary" :class="{'v-select-btn': !isAuto}" @click.stop="selectItem" :disabled="disabled">选择文件
            </button>
            <button type="button" class="btn btn-sm btn-primary" :class="{'v-upload-btn': !isAuto}" v-if="!isAuto" @click.stop="confirmUpload" :disabled="disabled">确定上传
            </button>
        </div>
        <div v-if="type === 'drag'" @click.stop="selectItem">
            <div class="v-icon-cloud-upload" :class="{'v-upload-disable': disabled === true}">
                <!-- <?xml version="1.0" encoding="utf-8"?> -->
                <!-- Generated by IcoMoon.io -->
                <!-- <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"> -->
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" viewBox="0 0 512 512">
                    <g id="icomoon-ignore">
                    </g>
                    <path d="M446.134 193.245c1.222-5.555 1.866-11.324 1.866-17.245 0-44.183-35.817-80-80-80-7.111 0-14.007 0.934-20.566 2.676-12.399-38.676-48.645-66.676-91.434-66.676-43.674 0-80.527 29.168-92.163 69.085-11.371-3.311-23.396-5.085-35.837-5.085-70.692 0-128 57.308-128 128 0 70.694 57.308 128 128 128h64v96h128v-96h112c44.183 0 80-35.816 80-80 0-39.36-28.427-72.081-65.866-78.755zM288 320v96h-64v-96h-80l112-112 112 112h-80z" fill="#99a9bf"></path>
                </svg>
            </div>
            <div class="v-upload-text">将文件拖拽到此处或者点击上传</div>
            <img :src="lastestFile.url" v-if="lastestFile.percentage === 100">
            <div v-show="lastestFile.percentage === 100" class="v-upload-modal">
                <span class="btn" @click.stop="deleteFile" :class="{'v-upload-disable': disabled === true}">
                    <i>
                        <!-- <?xml version="1.0" encoding="utf-8"?> -->
                        <!-- Generated by IcoMoon.io -->
                        <!-- <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"> -->
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" viewBox="0 0 512 512">
                            <g id="icomoon-ignore">
                            </g>
                            <path d="M64 160v320c0 17.6 14.4 32 32 32h288c17.6 0 32-14.4 32-32v-320h-352zM160 448h-32v-224h32v224zM224 448h-32v-224h32v224zM288 448h-32v-224h32v224zM352 448h-32v-224h32v224z" fill="#fff"></path>
                            <path d="M424 64h-104v-40c0-13.2-10.8-24-24-24h-112c-13.2 0-24 10.8-24 24v40h-104c-13.2 0-24 10.8-24 24v40h416v-40c0-13.2-10.8-24-24-24zM288 64h-96v-31.599h96v31.599z" fill="#fff"></path>
                        </svg>
                    </i>
                </span>
                <span class="btn" @click.stop="selectItem" :class="{'v-upload-disable': disabled === true}">
                    <i class="v-icon-upload-continue">
                        <!-- <?xml version="1.0" encoding="utf-8"?> -->
                        <!-- Generated by IcoMoon.io -->
                        <!-- <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"> -->
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" viewBox="0 0 512 512">
                            <g id="icomoon-ignore">
                            </g>
                            <path d="M0 448h512v32h-512zM512 384v32h-512v-32l64-128h128v64h128v-64h128zM112 160l144-144 144 144h-112v128h-64v-128z" fill="#fff"></path>
                        </svg>
                    </i>
                </span>
            </div>
        </div>
        <div v-if="type === 'imageList'">
            <ul>
                <li v-for="(file, index) in fileList" class="v-upload-img">
                    <v-popover placement="top" ref="popover">
                        <img :src="file.url" style="width: 440px;">
                        <div class="v-upload-img" slot="reference">
                            <img :src="file.url" v-if="file.percentage === 100">
                            <v-progress class="circle-progress" v-if="file.showProgress && showProgress" :width='100' type="circle" :stroke-width="4.8" :percentage="file.percentage" :status="file.percentage === 100 ? 'success' : ''">
                            </v-progress>
                            <div class="headImageTag" v-if="enableHeadImage && index === 0">首图</div>
                            <div v-show="file.percentage === 100" class="v-upload-modal">
                                <div style="width: 100%; bottom: 0; height: 30px; background-color: #06c1ae; position: absolute">
                                    <a @click.stop="deleteFile(file)" class="imageOperator" :class="{'v-upload-disable': disabled === true}">删除</a>
                                    <a v-if="enableHeadImage && index !== 0" @click.stop="setHeadImage(file)" class="imageOperator" style="float: right;" :class="{'v-upload-disable': disabled === true}">设为首图</a>
                                </div>
                            </div>
                        </div>
                    </v-popover>
                </li>
            </ul>
            <div class="v-upload-add plus" :class="{'v-upload-disable': disabled === true}" @click.stop="selectItem" v-show="fileList.length < maxLimit">
            </div>
        </div>
        <input type="file" class="v-upload-input" ref="input" @change="fileChange" :multiple="isMultiple" :accept="accept" :disabled="disabled">
    </div>

</template>

<style rel="stylesheet/css" lang="postcss">
.imageOperator {
  color: #fff;
  font-size: 12px;
  line-height: 30px;
  float: left;
  margin: 0 10px;
}
.headImageTag {
  left: 0;
  top: 10px;
  position: absolute;
  background: transparent;
  color: #fff;
  height: 0;
  width: 40px;
  border-top: 10px solid #ff9933;
  border-bottom: 10px solid #ff9933;
  border-right: 6px solid transparent;
  font-size: 12px;
  line-height: 0;
  text-align: center;
}
</style>
<script>
    export default {
      props: {
        type: {
          type: String,
          default: "fileList" // fileList or drag or imageList
        },
        disabled: {
          type: Boolean,
          default: false
        },
        fileList: {
          type: Array,
          default() {
            return [];
          }
        },
        isAuto: {
          type: Boolean,
          default: true
        },
        accept: {
          type: String
        },
        isMultiple: {
          type: Boolean,
          default: true
        },
        maxLimit: {
          type: Number
        },
        lastestFile: {
          type: Object,
          default() {
            return {};
          }
        },
        showProgress: {
          type: Boolean,
          default: true
        },
        enableHeadImage: {
          type: Boolean,
          default: false
        }
      },
      data() {
        return {
          dragover: false
        };
      },
      computed: {},
      watch: {},
      methods: {
        selectItem(e) {
          this.$refs.input.click();
        },
        fileChange(e) {
          if (!this.disabled) {
            const files = e.target.files || e.dataTransfer.files;
            if (!files) {
              return;
            }
            this.dragover = false;
            this.$emit("on-file-change", files);
            this.$refs.input.value = null;
          }
        },
        confirmUpload() {
          this.$emit("on-confirm-upload");
        },
        deleteFile(file) {
          event.preventDefault();
          // 因为popover有个消失延迟动画，所以这里先隐藏
          let popovers = document.getElementsByClassName("el-popover");
          for (let inx = 0; inx < popovers.length; ++inx) {
            popovers[inx].style.display = "none";
          }
          if (this.$refs.popover) {
            if (this.$refs.popover.length > 0) {
              for (let inx = 0; inx < this.$refs.popover.length; ++inx) {
                this.$refs.popover[inx].showPopper = false;
              }
            } else {
              this.$refs.popover.showPopper = false;
            }
          }
          this.$emit("on-delete-file", file);
        },
        setHeadImage(file) {
          event.preventDefault();
          // 因为popover有个消失延迟动画，所以这里先隐藏
          let popovers = document.getElementsByClassName("el-popover");
          for (let inx = 0; inx < popovers.length; ++inx) {
            popovers[inx].style.display = "none";
          }
          if (this.$refs.popover) {
            if (this.$refs.popover.length > 0) {
              for (let inx = 0; inx < this.$refs.popover.length; ++inx) {
                this.$refs.popover[inx].showPopper = false;
              }
            } else {
              this.$refs.popover.showPopper = false;
            }
          }
          this.$emit("on-set-head-image", file);
        }
      },
      created() {}
    };
</script>



// WEBPACK FOOTER //
// upload-select.vue?fffe1abc